import styled from 'styled-components'
import { COLORS } from 'theme'
import Flex from 'components/Flex'
import { FONT } from 'theme/font'

export const DrivDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_BASE};
  line-height: 21px;
  color: ${COLORS.GREY_T_30};
  padding: 0 0 15px 0;
  border-bottom: 1px solid ${COLORS.GREY_T_90};
`
export const DriveModeFlex = styled(Flex)`
  margin: 15px 0 25px;
`
export const DriveModeDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${COLORS.GREY_T_60};
  margin: 0 0 5px 0;
`
export const DriveNameDiv = styled.div`
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_SM};
  line-height: 21px;
  color: ${COLORS.GREY_T_30};
  text-transform: capitalize;
`
export const DriveTimeDiv = styled(Flex)`
  font-style: normal;
  font-weight: ${FONT.FW_400};
  font-size: ${FONT.F_SM};
  line-height: 20px;
  color: ${COLORS.GREY_T_30};
  margin: 7px 0 0 0;
  text-transform: capitalize;
`
